<div class="mapping-layout">
  <div class="dx-card mapping-card card-left">
    <div class="card-header">
      <div class="title">{{'Importkatalog' | translate}}</div>
      <div class="radio-grid">
        <div class="field-row-radio">
          <div class="field-label">{{ 'Anlage' | translate }}</div>
          <dx-radio-group
            [items]="attachRadioItems"
            valueExpr="value"
            displayExpr="text"
            layout="horizontal"
            [(value)]="radioAttachValue"
            (onValueChanged)="attachRadioChanged($event)"
            [elementAttr]="{ class: 'rg-compact' }">
          </dx-radio-group>
        </div>

        <div class="field-row-radio">
          <div class="field-label">{{ 'Gültigkeit' | translate }}</div>
          <dx-radio-group
            [items]="validityRadioItems"
            valueExpr="value"
            displayExpr="text"
            layout="horizontal"
            [(value)]="radioValidityValue"
            (onValueChanged)="validityRadioChanged($event)"
            class="rg-compact">
          </dx-radio-group>
        </div>

        <div class="field-row-radio">
          <div class="field-label">{{ 'Nullwerte' | translate }}</div>
          <dx-radio-group
            [items]="nullValueRadioItems"
            valueExpr="value"
            displayExpr="text"
            layout="horizontal"
            [(value)]="radioNullValueValue"
            [elementAttr]="{ class: 'rg-compact' }">
          </dx-radio-group>
        </div>
      </div>

      <div *ngIf="this.radioAttachValue == 'field'" class="import-fields">
        <label class="import-fields-label">{{ 'Import Felder (maximal 7 gleichzeitig auswählbar)' | translate }}:</label>
        <dx-drop-down-box
          [(value)]="selectedKeys"
          valueExpr="id"
          displayExpr="field"
          [dataSource]="dataSource"
          fieldTemplate="fieldTemplate"
          contentTemplate="content">

          <div *dxTemplate="let _ of 'fieldTemplate'">
            <dx-tag-box
              [dataSource]="dataSource"
              valueExpr="id"
              displayExpr="field"
              [(value)]="selectedKeys"
              [openOnFieldClick]="false"
              [showClearButton]="true"
              (onValueChanged)="onTagsChanged($event)">
            </dx-tag-box>
          </div>

          <div *dxTemplate="let _ of 'content'">
            <dx-tree-view
              #tree
              [dataSource]="treeData"
              dataStructure="plain"
              keyExpr="id"
              parentIdExpr="parentId"
              itemTemplate="treeItem"
              selectionMode="multiple"
              showCheckBoxesMode="none"
              [selectByClick]="false"
              (onContentReady)="onTreeContentReady($event)"
              (onSelectionChanged)="onTreeSelectionChanged($event)"
              (onItemClick)="onTreeItemClick($event)">

              <div *dxTemplate="let item of 'treeItem'">
                <div class="tree-row" [class.is-parent]="item.parentId == null">

                  <ng-container *ngIf="item.parentId != null; else groupTpl">
                    <div class="leaf-layout">
                      <dx-check-box
                        class="leaf-checkbox"
                        [value]="isSelected(item.id)"
                        [disabled]="isLeafDisabled(item.id)"
                        (onValueChanged)="onLeafCheckChanged(item.id, $event.value)">
                      </dx-check-box>

                      <div class="tree-item is-leaf">
                        <div class="tree-item__code">{{ item.field }}</div>
                        <div class="tree-item__name">{{ item.translatedField }}</div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #groupTpl>
                    <div class="tree-item is-parent">
                      <div class="tree-item__group">{{ item.translatedField }}</div>
                    </div>
                  </ng-template>

                </div>
              </div>
            </dx-tree-view>
          </div>
        </dx-drop-down-box>

      </div>
    </div>
  </div>

  <div class="dx-card mapping-card card-right">
    <div class="card-header">
      <div class="title">Golden Record</div>
      <div>Zielwerte im System</div>
      <div class="mapping-list">
        <label class="mapping-list-label">{{ 'Zu Mappingliste' | translate }}:</label>
        <dx-select-box
          [items]="mappingList"
          [(value)]="selectedMappingId"
          valueExpr="id"
          displayExpr="listName"
          (onValueChanged)="onMappingListSelectChanged($event)"
          [disabled]=""
          [searchEnabled]="true"
          [dropDownOptions]="dropDownCfg">
        </dx-select-box>
      </div>
    </div>
  </div>

  <div class="rows-wrapper">
    <dx-scroll-view class="rows-scroll-view" direction="vertical" [useNative]="true">
      <div class="rows-container">
        <dx-data-grid
          #mappingGrid
          [dataSource]="mappings"
          keyExpr="id"
          [showBorders]="true"
          [rowAlternationEnabled]="true"
          (onRowInserting)="onRowInserting($event)"
          (onSaved)="onSaveMappings()"
          (onRowPrepared)="onRowPrepared($event)">

          <dxo-editing
            mode="row"
            [allowAdding]="true"
            [allowDeleting]="true"
            [allowUpdating]="true"
            [useIcons]="true">
            <dxo-texts
              confirmDeleteMessage="{{ 'Wollen Sie diesen Eintrag wirklich löschen' | translate }}?"
              confirmDeleteTitle="{{ 'Eintrag löschen' | translate }}"
              addRow="{{ 'Neuen Eintrag erstellen' | translate }}">
            </dxo-texts>
          </dxo-editing>

          <dxo-toolbar>
            <dxi-item name="addRowButton" showText="always" location="after" [disabled]="!listSelected"></dxi-item>
            <dxi-item location="after">
              <dx-button
                text="{{ 'Auto Mapping' | translate }}"
                type="default"
                stylingMode="contained"
                [disabled]="!listSelected"
                (onClick)="runAutoMapping()">
              </dx-button>
            </dxi-item>
          </dxo-toolbar>

          <dxi-column dataField="value" [caption]="value" [allowEditing]="true"></dxi-column>
          <dxi-column dataField="key"   [caption]="key"   [allowEditing]="true"></dxi-column>
        </dx-data-grid>
      </div>
    </dx-scroll-view>
  </div>
</div>


<dx-popup [showTitle]="true"
          title="{{ 'Mappingliste erstellen' | translate }}"
          [dragEnabled]="true"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="addMappingListVisible"
          contentTemplate="popupContent"
          height="30%"
          width="30%">
  <dxi-popup-toolbar-item toolbar="bottom" location="after" widget="dxButton" [options]="{ stylingMode: 'outlined', text: 'Liste Erstellen' | translate, onClick: addMappingList }"></dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newMappingList.listName" [showClearButton]="true"></dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Schlüssel-Spalten Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newMappingList.key" [showClearButton]="true"></dx-text-box>
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Wert-Spalten Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="newMappingList.value" [showClearButton]="true"></dx-text-box>
      </div>
    </div>
  </div>
</dx-popup>
